import React from 'react';
import { useSiteContent } from '../context/SiteContentContext';
import Hero from '../components/home/Hero';
import IntroVideo from '../components/home/IntroVideo';
import AboutTeaser from '../components/home/AboutTeaser';
import MissionTeaser from '../components/home/MissionTeaser';
import StoryTeaser from '../components/home/StoryTeaser';
import VisionMissionValues from '../components/home/VisionMissionValues';
import WhatWeOffer from '../components/home/WhatWeOffer';
import WhyChooseUs from '../components/home/WhyChooseUs';
import FreeTrialClass from '../components/home/FreeTrialClass';
import Testimonials from '../components/home/Testimonials';
import HowItWorks from '../components/home/HowItWorks';
import FAQ from '../components/home/FAQ';
import CTABottom from '../components/home/CTABottom';

const Home = () => {
  const { siteContent, loading } = useSiteContent();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-slate-900"></div>
      </div>
    );
  }

  const isVisible = (section) => siteContent?.[section]?.visible !== false;

  return (
    <div>
      {/* 1. Hero */}
      {isVisible('hero') && <Hero />}
      
      {/* 2. Intro Video Section */}
      {isVisible('introVideo') && <IntroVideo />}
      
      {/* 3. About Us Teaser */}
      {isVisible('aboutTeaser') && <AboutTeaser />}
      
      {/* 3. Mission Teaser */}
      {isVisible('missionTeaser') && <MissionTeaser />}
      
      {/* 4. Story Teaser */}
      {isVisible('storyTeaser') && <StoryTeaser />}
      
      {/* 5. Vision, Mission & Values */}
      {isVisible('visionMissionValues') && <VisionMissionValues />}
      
      {/* 6. What We Offer (grid with icons) */}
      {isVisible('whatWeOffer') && <WhatWeOffer />}
      
      {/* 7. Why Choose Us (icons + short bullets) */}
      {isVisible('whyChooseUs') && <WhyChooseUs />}
      
      {/* 8. Free Trial Class */}
      {isVisible('freeTrialClass') && <FreeTrialClass />}
      
      {/* 9. Testimonials */}
      {isVisible('testimonials') && <Testimonials />}
      
      {/* 10. How It Works (3-step flow) */}
      {isVisible('howItWorks') && <HowItWorks />}
      
      {/* 11. FAQ */}
      {isVisible('faq') && <FAQ />}
      
      {/* 12. Final CTA */}
      {isVisible('finalCta') && <CTABottom />}
    </div>
  );
};

export default Home;
